// jshint esversion: 11
// const script_name = new URL(import.meta.url).pathname.split('/').pop();


!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="51ba35a0-9e74-5a8e-96f1-edda518abda2")}catch(e){}}();
import {get_model_from_storage} from '/static/js/local_storage.js';
import {applyPermitLimitToList, startPermitLimitTopic} from '/static/js/permit-limit-topic.js';
// import {getJSONData} from '/static/js/network.js';
// import {Schedule} from '/static/js/schedule.js';

// module_loader(script_name, ['network', 'local_storage']);

/** Row spec for permit-limits tables: [label, kind, key, extraClass?]
 *
 * Kinds:
 *   bare       Show permitted[key] (limit) verbatim, no usage overlay.
 *   bool       Show permitted[key] as Yes/No.
 *   usage      "consumed of permitted" when consumed[key] is set; otherwise
 *              fall back to the bare permitted[key]. Used for rows whose
 *              label names the limit ("Permits per tag", "Rolling window
 *              days"), so the community-config fieldset (no tag entered,
 *              consumed = {}) still shows the configured limit value.
 *   usage-only "consumed of permitted" when consumed[key] is set; otherwise
 *              blank. Used for rows whose label explicitly names the
 *              *consumption* ("Days used in period") — showing just the
 *              limit there would misrepresent the policy as if days had
 *              been used.
 */
const PERMIT_LIMITS_ROW_SPEC = [
    ['Period name',               'bare',       'period_name'],
    ['Consecutive allowed',       'bool',       'consecutive'],
    ['Days per permit (default)', 'bare',       'days_per_permit'],
    ['Max consecutive days',      'bare',       'max_consecutive_days'],
    ['Days per period',           'bare',       'days_per_period'],
    ['Permits per address',       'usage',      'permits_per_address'],
    ['Permits per community',     'usage',      'permits_per_community'],
    ['Permits per tag',           'usage',      'permits_per_tag'],
    ['Rolling window days',       'usage',      'rolling_window_days'],
    ['Days used in period',       'usage-only', 'days_per_period', 'allowed-usage'],
];

function __mapCommunityRowToPermitted(row) {
    return {
        period_name: row.period ?? row.period_name,
        consecutive: row.consecutive,
        days_per_permit: row.days_per_permit,
        max_consecutive_days: row.max_consecutive_days,
        days_per_period: row.days_per_period,
        permits_per_address: row.permits_per_address,
        permits_per_community: row.permits_per_community,
        permits_per_tag: row.permits_per_tag,
        rolling_window_days: row.rolling_window_days,
    };
}

function __sourcesFromCommunityPermitLimits(permit_limits) {
    return permit_limits.map((row) => ({
        id: row.id,
        permitted: __mapCommunityRowToPermitted(row),
        consumed: {},
    }));
}

function __sourcesFromLimitsResponse(limits) {
    if (Array.isArray(limits.per_limit) && limits.per_limit.length > 0) {
        return limits.per_limit;
    }
    return [{
        id: null,
        permitted: limits.permitted || {},
        consumed: limits.consumed || {},
        permit_override_in_period: !!limits.permit_override_in_period,
    }];
}

function __buildPermitLimitsTableFragment(sources) {
    const fmtBare = (val) => {
        if (val === null || val === undefined || val === '' || val === -1) return '';
        return val;
    };
    const fmtUsage = (used, limit) => {
        if (limit === null || limit === undefined || limit === -1) return '';
        return `${used} of ${limit}`;
    };
    const fmtBool = (val) => {
        // null/undefined => "not configured" — keep the cell blank so an
        // unset policy field isn't misread as the explicit choice "No".
        if (val === null || val === undefined) return '';
        return val ? 'Yes' : 'No';
    };
    const isOverLimit = (used, limit) => (
        limit !== null && limit !== undefined && limit !== -1
        && used !== null && used !== undefined && used > limit
    );
    // Over-limit: 🎫 only when a PermitLimitOverride exists for this tag in
    // the period; otherwise ⚠️ (overage can be date edits / lowered caps).
    const writeUsageCell = (td, used, limit, hasGoldenTicket = false) => {
        const text = fmtUsage(used, limit);
        if (!text) return;
        if (isOverLimit(used, limit)) {
            const marker = document.createElement('span');
            if (hasGoldenTicket) {
                marker.classList.add('golden-ticket');
                marker.title = `Golden Ticket override: ${used} used vs limit of ${limit}`;
                marker.textContent = '🎫';
            } else {
                marker.classList.add('over-limit-warning');
                marker.title = `Over limit: ${used} used vs limit of ${limit}`;
                marker.textContent = '⚠️';
            }
            td.appendChild(marker);
            td.appendChild(document.createTextNode(` ${text}`));
        } else {
            td.textContent = text;
        }
    };

    const fragment = document.createDocumentFragment();

    const thead = document.createElement('thead');
    const headRow = document.createElement('tr');
    const cornerTh = document.createElement('th');
    cornerTh.classList.add('permit-limits-corner');
    headRow.appendChild(cornerTh);
    sources.forEach((src) => {
        const th = document.createElement('th');
        th.classList.add('permit-limits-pk');
        th.scope = 'col';
        th.textContent = src.id != null ? `#${src.id}` : '';
        headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    fragment.appendChild(thead);

    const tbody = document.createElement('tbody');
    PERMIT_LIMITS_ROW_SPEC.forEach(([label, kind, key, extraClass]) => {
        const tr = document.createElement('tr');
        if (extraClass) tr.classList.add(extraClass);
        const labelTh = document.createElement('th');
        labelTh.scope = 'row';
        labelTh.classList.add('permit-limits-label');
        if (extraClass) labelTh.classList.add(extraClass);
        labelTh.textContent = label;
        tr.appendChild(labelTh);
        sources.forEach((src) => {
            const td = document.createElement('td');
            td.classList.add('permit-limits-value');
            if (extraClass) td.classList.add(extraClass);
            const permitted = src.permitted || {};
            const consumed = src.consumed || {};
            if (kind === 'bool') {
                td.textContent = fmtBool(permitted[key]);
            } else if (kind === 'usage') {
                const used = consumed[key];
                if (used === null || used === undefined) {
                    // No tag entered yet (community-config view): show the
                    // configured limit so the row is not a blank mystery.
                    td.textContent = fmtBare(permitted[key]);
                } else {
                    writeUsageCell(td, used, permitted[key], !!src.permit_override_in_period);
                }
            } else if (kind === 'usage-only') {
                const used = consumed[key];
                if (used === null || used === undefined) {
                    td.textContent = '';
                } else {
                    writeUsageCell(td, used, permitted[key], !!src.permit_override_in_period);
                }
            } else {
                td.textContent = fmtBare(permitted[key]);
            }
            tr.appendChild(td);
        });
        tbody.appendChild(tr);
    });
    fragment.appendChild(tbody);

    return fragment;
}

export class Communities {
    constructor() {
        // access the data models for the community with this.data
        this.community = null; // data models for said
        this.communityId = 0;
        this.communities = this.community;
        this.communityprivate = null;
        this.value = null; // ephemeral
        this.daysPerPermit = 14; // this should always be set by the API
        this.daysPerPeriod = 31; // this should always be set by the API

        this.use_id_code = true;
        startPermitLimitTopic((detail) => this.applyPermitLimitEvent(detail));
    }

    /**
     * Merge one ``pr.permitlimit.*`` event into this community cache and redraw
     * the permit-limits table when it is showing this community.
     *
     * @param {{action: string, payload: object}} detail
     */
    applyPermitLimitEvent(detail) {
        const payload = detail?.payload || {};
        const communityId = Number(payload.community_id);
        const data = this.community?.data;
        if (!data || !communityId) {
            return;
        }
        const community = data[communityId] ?? data[String(communityId)];
        if (!community) {
            return;
        }
        community.permit_limits = applyPermitLimitToList(
            community.permit_limits,
            detail.action,
            payload,
        );
        if (Number(this.communityId) !== communityId) {
            return;
        }
        const table = document.querySelector('#permit-limits');
        if (table) {
            this.drawPermitLimitsAndUsage({table});
        }
    }

    // load the data from localStorage (under the hood, if localStorage
    // isn't available, it's fetched from the network)
    load() {
        const models = {Community: true};

        const p = Promise.all(
                Object.keys(models)
                    .map((model) => {
                        return get_model_from_storage(model)
                            .then((data) => {
                                this[model.toLowerCase()] = data;
                            })
                            ;
                    })
            )
                .then(() => this)
                .catch((err) => {
                    throw err;
                })
        ;

        return p;
    }

    set(kv) {
        Object.entries(kv).forEach(([k, v]) => {
            this[k] = v;
        });
        return this;
    }

    isValidCommunityId({parent, community_data} = {}) {
        if (!parent) {
            return false;
        }

        const communityId = getCommunityId({parent: parent, community_data: community_data});
        return communityId > 0;
    }

    /*
     * Get the community ID from the community ID code.
     * First we need figure out if we're getting data from the
     * <select> or the <input> field.
     * If it's the input, we need to translate it to a community ID.
     * @param {number} communityIdCode - The community ID code
     * @returns {number} The community ID
     */
    findSetCommunityId(target) {
        this.communityId = getCommunityId({
            parent: target,
            community_data: this.community.data
        });
        return this;
    }

    setElementCommunityName() {
        const communityIdCodeInput = document.querySelector('#community-id-code');  
        if (!communityIdCodeInput) {
            // don't set the name if we don't have the corresponding input field
            return this;
        }

        let name = '';

        if (this.communityId === 0) {
            name = ''
        } else {
            name = this.community.data[this.communityId].name;
        }
        
        document.querySelector('.community-name').textContent = name;
        return this;
    }

    setElementCommunityIdCode(communityIdCode) {
        // console.warn('setElementCommunityIdCode()');
        if (!communityIdCode) {
            communityIdCode = this.communityIdCode;
        }

        const communityIdCodeInput = document.querySelector('#community-id-code');

        if (!communityIdCodeInput) {
            console.log('no community id code input element found');
            return this;
        }

        // console.log('setting element community id code', communityIdCode);
        communityIdCodeInput.value = communityIdCode;

        return this;
    }

    // utility functions
    clearChildren({target} = {}) {
        if (target) {
            while (target.lastElementChild) {
                target.lastElementChild.remove();
            }
        }

        return this;
    }

    attachTo({target, clearChildren = true} = {}) {
        // console.warn('attachTo(target=', target, 'clearChildren=', clearChildren, this.value);
        if (!target) {
            this.value = undefined;
            return this;
        }

        if (clearChildren) {
            this.clearChildren({target});
        }

        if (this.value === undefined) {
            return this;
        }

        target.append(this.value);

        return this;
    }

    makeOptions({communityId = 0, forceSelection = false, allowedItems, purpose} = {}) {
        // build a set of <select> options, if a selectedIndex is set, the output
        // will reflect such. if forceSelection is set, then once the <select> is
        // activated, the user must choose a non-default value
        // console.warn('makeOptions(communityId=', communityId, 'forceSelection=', forceSelection, 'allowedItems=', allowedItems, 'purpose=', purpose);

        const fragment = document.createDocumentFragment();
        const option = document.createElement('option');
        option.text = '--- Select Community ---';
        option.value = 0;
        option.disabled = forceSelection;

        if (!this.community) {
            console.warn('community data not loaded yet');
            return this;
        }

        if (!communityId) {
            option.selected = true;
        }

        fragment.appendChild(option);

        Object.values(this.community.data)
            .sort((a, b) => (a.name > b.name) ? 1 : ((a.name < b.name) ? -1 : 0))
            .forEach((c) => {

                // if (allowedItems !== undefined) {
                //   if (allowedItems.indexOf(c.id) < 0) {
                //     return;
                //   }
                // }
                // console.log(c);

                if (c.id === 0) {
                    return;
                }

                const option = document.createElement('option');
                option.value = c.id;
                option.text = c.name;

                if (c.active === false) {
                    return;
                    // option.text = `🕸️ ${c.name} (inactive)`;
                    // option.disabled = true;
                }

                if (c.id === communityId) {
                    option.selected = true;
                }

                if (purpose === 'permit') {
                    if (c.pr_guest_registrations === false && c.pr_resident_registrations === false) {
                        option.text = `⛔ ${c.name} (ParkRanger permits not available for this community)`;
                        option.disabled = true;
                    }
                }

                if (c.active && (c.pr_resident_registrations === true || c.pr_guest_registrations === true)) {
                    option.text = `🏷️${option.text}`;
                }

                if (allowedItems && allowedItems.indexOf(c.id) < 0) {
                    option.disabled = true;
                }

                fragment.appendChild(option);
            });

        this.value = fragment;

        return this;
    }

    setSelectedIndex({
                         target,
                         communityId = 0,
                         satisfyInputNeeded = false,
                         disableChanges = false,
                         dispatchEvent = true
                     } = {}) {
        communityId = parseInt(communityId, 10);

        // console.warn(`set selectedIndex to ${communityId}`, target);
        // // target.selectedIndex =

        if (!target) {
            return this;
        }

        target.value = communityId;
        [...target.querySelectorAll('option')]
            .map((o, index) => {
                if (parseInt(o.getAttribute('value'), 10) === parseInt(communityId, 10)) {
                    target.selectedIndex = index;
                    // console.warn(`set it to ${index}`);
                }
            });

        if (satisfyInputNeeded) {
            target.removeAttribute('data-input-needed');
        }

        if (disableChanges) {
            target.setAttribute('disabled', true);
        }

        if (dispatchEvent) {
            const evt = new Event('change', {bubbles: true});
            // console.warn('dispatching event');
            target.dispatchEvent(evt);
        }

        return this;
    }

    notActive(communityId) {
        if (communityId === undefined || isNaN(communityId)) {
            communityId = this.communityId;
        }

        if (communityId && !this.communityId) {
            this.communityId = communityId;
        }

        if (communityId <= 0 || communityId === undefined) {
            return true;
        }

        if (this.community.deactivated && this.community.deactivated.indexOf(communityId) >= 0) {
            console.warn(`this communityId(${communityId}) has been deactivated`);
            alert('🔔 This community where you previously registered is no longer serviced by us. Please check signs posted in community');
            return true;
        }
    }

    setStreetAddressRequiredFields({parent, communityId} = {}) {
        if (communityId === undefined) {
            communityId = this.communityId;
        }

        // May alert when deactivated; still sync field attrs for the new selection.
        this.notActive(communityId);

        syncStreetAddressRequiredFields({
            parent,
            communityId,
            community_data: this.community?.data,
        });

        return this;
    }

    // the methods below here all rely on a previous call which sets this.id
    //
    // The community public cache returns `permit_limits` as an array (0+ rows;
    // 1 row was the historical case, ≤2 rows is the supported UI scale, the
    // engine handles N rows). Each row dict comes from Django `model_to_dict`
    // for the `PermitLimit` model -- so the period field is keyed `period`,
    // not `period_name` (engine PCM data uses `period_name`; we accept both).
    //
    // Output shape: a DocumentFragment containing a <thead> + <tbody> meant to
    // be appended into the existing `<table id="permit-limits">` element by
    // `attachTo()`. The header row carries one <th> per PermitLimit row (with
    // its primary key) above an empty leading cell that lines up with the
    // metric-label column below.
    buildPermitLimitsBlock({communityId} = {}) {
        if (communityId === undefined) {
            communityId = this.communityId;
        }

        if (this.notActive(communityId)) {
            console.warn('community is not active, skipping buildPermitLimitsBlock');
            this.value = undefined;
            return this;
        }

        const permit_limits = this.community.data[communityId].permit_limits;

        this.value = undefined;

        if (!Array.isArray(permit_limits) || permit_limits.length === 0) {
            return this;
        }

        const sources = __sourcesFromCommunityPermitLimits(permit_limits);
        this.value = __buildPermitLimitsTableFragment(sources);
        return this;
    }

    /*
     * Draw the permit limits and usage block. The backend is the single source
     * for what `permitted` values mean (see docs/PERMIT_LIMIT_RULES.md). When
     * `limits` is undefined, we render an empty placeholder rather than guess
     * defaults; live values arrive via `Api_GetPermitLimitsForTag` once a tag
     * is entered.
     *
     * `limits` may carry a `per_limit: [...]` array (intersection engine
     * output, 0+ rows). When present, each row gets its own column-stack so
     * managers can compare policies side-by-side. The legacy single-source
     * shape (flat `permitted` / `consumed`) still renders as a single column.
     *
     * @param {HTMLElement} parent - The parent element to draw the block into
     * @param {Object} limits - The limits object to draw
     * @returns {Communities} The Communities object
     */
    drawPermitLimitsAndUsage({table, parent, limits} = {}) {
        const tableEl = table || parent?.closest('table') || document.querySelector('#permit-limits');
        if (!tableEl) {
            console.warn('no table for drawPermitLimitsAndUsage');
            return this;
        }

        let sources;
        if (limits) {
            sources = __sourcesFromLimitsResponse(limits);
        } else {
            const communityId = this.communityId;
            const permit_limits = this.community?.data?.[communityId]?.permit_limits;
            if (!Array.isArray(permit_limits) || permit_limits.length === 0) {
                while (tableEl.lastElementChild) {
                    tableEl.lastElementChild.remove();
                }
                return this;
            }
            sources = __sourcesFromCommunityPermitLimits(permit_limits);
        }

        while (tableEl.lastElementChild) {
            tableEl.lastElementChild.remove();
        }
        tableEl.appendChild(__buildPermitLimitsTableFragment(sources));

        return this;
    }
}

/*
 * This function takes a prefilled response object
 */
export function populate_community(data, parent, selectedIndex, prefix = '') {
    const evt = new Event('change', {bubbles: true});

    if (typeof parent === 'string') {
        parent = document.querySelector(parent);
    }

    console.warn('legacy code to remove, use the new Community() object');
    const SELECT = parent.querySelector(`SELECT[data-id="${prefix}community"]`);

    // start off by nulling our selection
    SELECT.options.selectedIndex = 0;

    // now, if our API response was empty, return
    if (!data) {
        return;
    }

    // build a list of options that are >0
    const options = [...SELECT.querySelectorAll('option')]
        .filter((el) => el.value > 0)
        .map((inner_el) => parseInt(inner_el.value, 10));

    // make sure the last-used community is still an available
    // community option, ignore if not
    // holdover, make it go away please
    if (options.indexOf(data.id) > -1) {
        SELECT.value = data.id;
        SELECT.dispatchEvent(evt);
    }

    if (options.indexOf(selectedIndex) > -1) {
        SELECT.value = selectedIndex;
        SELECT.dispatchEvent(evt);
    }
}

export const get__community = (community) => {
    return get_model_from_storage('Community')
        .then((model) => {
            return Promise.resolve(model.data[community]);
        });
};

export function getCommunityInput(target) {
    let el = target.querySelector('[name$="community"]');

    if (el) {
        target = el;
    }

    el = target.querySelector('[name$="community-id-code"]');
    if (el) {
        target = el;
    }

    return target;
}

/**
 * Apply street-address required / data-input-needed from community.has_subpremise.
 * Safe to call on community change before address revalidation so attrs from a
 * previous community (e.g. Blue Labs → #52) do not linger.
 *
 * @param {object} opts
 * @param {HTMLElement} opts.parent - Section or #community-street-address root
 * @param {number|string} [opts.communityId]
 * @param {object} [opts.community_data] - Communities cache map id → community
 * @returns {boolean} Whether subpremise is required for this community
 */
export function syncStreetAddressRequiredFields({parent, communityId, community_data} = {}) {
    if (!parent) {
        return false;
    }

    // Prefer exact INPUT ids. Bare `$=address-*` also matches yellow example
    // spans (`community-example-address-subpremise`, etc.).
    const streetNumberEl = parent.querySelector('input[data-id="address-street-number"]')
        || parent.querySelector('input[data-id$="address-street-number"]');
    const routeEl = parent.querySelector('input[data-id="address-route"]')
        || parent.querySelector('input[data-id$="address-route"]');
    const subpremiseEl = parent.querySelector('input[data-id="address-subpremise"]')
        || parent.querySelector('input[data-id$="address-subpremise"]');

    if (!streetNumberEl || !routeEl || !subpremiseEl) {
        return false;
    }

    streetNumberEl.setAttribute('required', true);
    routeEl.setAttribute('required', true);

    const id = parseInt(communityId, 10) || 0;
    let has_subpremise = false;
    if (id > 0) {
        const community = community_data?.[id] ?? community_data?.[String(id)];
        // Unknown cache entry: keep requiring (safer). Explicit false/null → not required.
        has_subpremise = community ? !!community.has_subpremise : true;
    }

    if (has_subpremise) {
        subpremiseEl.setAttribute('required', true);
    } else {
        subpremiseEl.removeAttribute('required');
    }

    const split = parent.querySelector('dl.split-address') || parent.closest?.('dl.split-address');
    if (split?.dataset) {
        split.dataset.communityHasSubpremise = has_subpremise ? 'true' : 'false';
    }

    [streetNumberEl, routeEl, subpremiseEl].forEach((el) => {
        if (el.hasAttribute('required')) {
            if (!(el.value || '').length) {
                el.setAttribute('data-input-needed', true);
            } else {
                el.removeAttribute('data-input-needed');
            }
        } else {
            el.removeAttribute('data-input-needed');
        }
    });

    return has_subpremise;
}

/**
 * Resolve whether the selected community requires a subpremise.
 * Prefers {@code data-community-has-subpremise} stamped by syncStreetAddressRequiredFields.
 *
 * @param {HTMLElement} [parent] - Address section / split-address ancestor
 * @param {object} [community_data] - Optional communities cache
 * @param {number|string} [communityId]
 * @returns {boolean}
 */
export function communityRequiresSubpremise({parent, community_data, communityId} = {}) {
    const split = parent?.querySelector?.('dl.split-address')
        || parent?.closest?.('dl.split-address')
        || parent;
    const flag = split?.dataset?.communityHasSubpremise;
    if (flag === 'true') {
        return true;
    }
    if (flag === 'false') {
        return false;
    }

    const id = parseInt(communityId, 10) || 0;
    if (id > 0 && community_data) {
        const community = community_data[id] ?? community_data[String(id)];
        if (community) {
            return !!community.has_subpremise;
        }
    }
    return true;
}

/**
 * Get the community ID from a select/input or a parent that contains one.
 *
 * @param {HTMLElement} parent - Community field or containing section
 * @param {Object} [community_data] - Required to translate community-id-code inputs
 * @returns {number} The community ID
 */
export function getCommunityId({parent, community_data} = {}) {
    let value = 0;

    // if the parent is not the select or input field, then we need to find it
    // within the parent section
    console.info('getCommunityId(parent=', parent);
    if (parent.tagName !== 'SELECT' && parent.tagName !== 'INPUT') {
        parent = getCommunityInput(parent);
        if (!parent) {
            console.warn('no community or community-id-code field found in parent');
            return 0;
        }
    }

    // ok, now we have the parent element, we need to get the value
    value = parseInt(parent.value, 10) || 0
    if (parent.tagName === 'SELECT') {
        console.log('returning value from select', value);
        return value;
    }

    if (community_data === undefined) {
        console.warn('no community_data provided');
        return 0;
    }

    // we're left with the input field, so we need to translate the value to a community ID
    value = translateCommunityCodeToId(community_data, value);
    // console.warn(`return getCommunityId(value=${value})`);
    return value;
}

export function translateCommunityCodeToId(cdata, communityIdCode) {
    // console.warn('translateCommunityCodeToId(cdata, communityIdCode)', cdata, communityIdCode);
    const community = Object.values(cdata).find((c) => c.id_code === communityIdCode);
    const id = community ? community.id : 0;
    // console.warn(`  translateCommunityCodeToId(communityIdCode=${communityIdCode}) => community=${id}`);
    return id;
}

//# debugId=51ba35a0-9e74-5a8e-96f1-edda518abda2
